module.exports = __webpack_public_path__ + "img/mode-dark.69e096cc.svg";